import React, { Component } from "react";
import { Link } from "react-router-dom";
import { SideBar, NavBar, TitleAndDescription, Footer } from "../../components";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import PouchDB from "pouchdb";
import PouchdbFind from "pouchdb-find";
// import "./PedidoNovo.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import tipoPedidoModel from "../../models/tipoPedido";
import clienteModel from "../../models/cliente";
import condPagamentoModel from "../../models/condPagamento";
import formaPagamentoModel from "../../models/formaPagamento";
import transportadoraModel from "../../models/transportadora";
import sequenciaPedidoModel from "../../models/sequenciaPedido";
import saldoReservaModel from "../../models/saldoReserva"; //NÃO É UTILIZADO
import usuarioModel from "../../models/usuario";
import saldoOverModel from "../../models/saldoOver";
import pedidoModel from "../../models/pedido";
import produtoModel from "../../models/produto";
import agendaModel from "../../models/agenda";
import orcamentoModel from "../../models/orcamento";
import vendedorModel from "../../models/vendedor";
import AsyncSelect from "react-select/async";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
} from "reactstrap";
import descontoModel from "../../models/desconto";
import queryString from "query-string";
import axios from "axios";
import moment from "moment";
import debounce from "debounce-promise";
require("dotenv").config();
const { formatarReal } = require("../../utils");
const { formatarCasaDecimal } = require("../../utils");
PouchDB.plugin(PouchdbFind);

let VALIDAR_ESTOQUE = localStorage.getItem("validarEstoque");

if (VALIDAR_ESTOQUE === null) {
  VALIDAR_ESTOQUE = true;
} else {
  VALIDAR_ESTOQUE = VALIDAR_ESTOQUE === "true" ? true : false;
}

let PERMITIR_ALTERAR_CONDICAO_PAGAMENTO = localStorage.getItem(
  "permitirAlterarCondicaoPagamento"
);

if (PERMITIR_ALTERAR_CONDICAO_PAGAMENTO === null) {
  PERMITIR_ALTERAR_CONDICAO_PAGAMENTO = true;
} else {
  PERMITIR_ALTERAR_CONDICAO_PAGAMENTO =
    PERMITIR_ALTERAR_CONDICAO_PAGAMENTO === "true" ? true : false;
}

export default class PedidoNovo extends Component {
  constructor(props) {
    super(props);
    this.loadUsuario = this.loadUsuario.bind(this);
    this.calcularTotalPedido = this.calcularTotalPedido.bind(this);
    this.loadPedidoStorage = this.loadPedidoStorage.bind(this);
    this.loadSequenciaPedido = this.loadSequenciaPedido.bind(this);
    this.setTipoPedidoPadrao = this.setTipoPedidoPadrao.bind(this);
    this.load = this.load.bind(this);
    this.localizacao = this.localizacao.bind(this);
    this.getLocation = this.getLocation.bind(this);
    this.bloqueio = this.bloqueio.bind(this);
    this.handleChangeSelect = this.handleChangeSelect.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.validarPedido = this.validarPedido.bind(this);
    this.setarInfoSugerida = this.setarInfoSugerida.bind(this);
    this.getDefaultPedido = this.getDefaultPedido.bind(this);
    this.transformDataComboBox = this.transformDataComboBox.bind(this);
    this.buscaDadosCliente = this.buscaDadosCliente.bind(this);
    this.promiseOptions = this.promiseOptions.bind(this);
    this.abrirPaginaNovoCliente = this.abrirPaginaNovoCliente.bind(this);
    this.abrirPaginaInfoPedido = this.abrirPaginaInfoPedido.bind(this);
    this.calcularValorDesconto = this.calcularValorDesconto.bind(this);
    this.verificaLegendaCliente = this.verificaLegendaCliente.bind(this);
    this.promiseOptionsDesconto = this.promiseOptionsDesconto.bind(this);
    this.removeDesconto = this.removeDesconto.bind(this);
    this.toggle = this.toggle.bind(this);
    this.abrirPaginaEditarContatos = this.abrirPaginaEditarContatos.bind(this);
    this.loadParametros = this.loadParametros.bind(this);
    this.atualizaSaldoOver = this.atualizaSaldoOver.bind(this);
    this.abrirPaginasEtapa = this.abrirPaginasEtapa.bind(this);
    this.verificaLegendaCliente = this.verificaLegendaCliente.bind(this);
    this.buscarTitulosAtraso = this.buscarTitulosAtraso.bind(this);
    this.toggleModalTitulos = this.toggleModalTitulos.bind(this);
    this.verificaAutenticacao = this.verificaAutenticacao.bind(this);

    this.debouncedLoadOptions = debounce(
      (inputValue) => this.promiseOptions(inputValue),
      500,
      {
        leading: true,
      }
    );

    this.state = {
      //actionPage: this.props.action,
      idPedido: null,
      actionPage: "CADASTRAR",
      tiposPedido: [],
      clientes: [],
      condicoesPagamento: [],
      formasPagamento: [],
      transportadoras: [],
      pedido: this.getDefaultPedido(),
      contatos: [],
      enderecos: [],
      totalPedido: 0,
      usuario: null,
      codigoPedido: "",
      localizacao: false,
      errors: {
        tipoPedido: false,
        cliente: false,
        condPagto: false,
        formaPagto: false,
        transportadora: false,
        contato: false,
        endereco: false,
      },
      db: null,
      exibirLegendaCliente: false,
      textoLegenda: "",
      limiteCreditoCliente: null,
      corLegenda: "",
      descontos: [],
      listaDivergencias: [],
      modalDivergencias: false,
      modal: false,
      idCliente: null,
      habilitarCampoCondicao: true,
      parametros: null,
      existeTitulosAtraso: false,
      modalTitulos: false,
      valorTitulos: 0,
      titulosAtraso: [],
    };
  }

  async componentDidMount() {
    let idPedido = queryString.parse(this.props.location.search).id;
    let actionPage = this.state.actionPage;

    if (idPedido !== undefined) {
      actionPage = "EDITAR";
    }

    let db = await new PouchDB(this.props.getBaseUrlBanco(), {
      auth: this.props.getUserBanco(),
      skipSetup: true,
    });

    this.setState(
      {
        actionPage,
        idPedido,
        db: db,
      },
      async () => {
        await this.loadUsuario();
        await this.loadParametros();
        await this.load();
        await this.loadPedidoStorage();

        if (this.state.actionPage !== "EDITAR") {
          await this.loadSequenciaPedido();
          await this.setTipoPedidoPadrao();
        }

        await this.calcularTotalPedido();
        await this.getLocation();
        await this.verificaAutenticacao();
      }
    );
  }

  async localizacao() {
    let loc = false;
    await navigator.permissions
      .query({ name: "geolocation" })
      .then(function (result) {
        loc = result.state;
      });
    this.setState({ localizacao: true });
  }

  async getLocation() {
    if (navigator.geolocation) {
      await navigator.geolocation.getCurrentPosition(
        // Success function
        this.localizacao,
        // Error function
        this.bloqueio,
        // Options. See MDN for details.
        {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0,
        }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }

  async bloqueio() {
    this.setState({ localizacao: false });
  }

  async loadUsuario() {
    let usuario = await usuarioModel.find(this.state.db);
    this.setState({ usuario });
  }

  async loadParametros() {
    let query = {
      selector: {
        type: { $eq: "parametros" },
      },
      limit: 1,
    };

    let result = await this.state.db.find(query);
    let parametros = result.docs[0];

    this.setState({ parametros });
  }

  async calcularTotalPedido() {
    if (this.state.pedido.itens.length) {
      let totalPedido = 0;

      for (let item of this.state.pedido.itens) {
        let valor = item.produto.preco.precoUnitComImpostosFinal;

        if (this.state.parametros.tipoDesconto === "progressivo") {
          if (
            this.state.pedido.desconto !== null &&
            this.state.pedido.desconto.pDesc !== 0
          ) {
            valor = this.calcularValorDesconto(
              valor,
              this.state.pedido.desconto.pDesc
            );
          }
        } else {
          if (
            this.state.pedido.condPagto !== null &&
            this.state.pedido.condPagto.pDesc !== 0
          ) {
            valor = this.calcularValorDesconto(
              valor,
              this.state.pedido.condPagto.pDesc
            );
          }
        }

        valor = item.quantidade * valor;

        totalPedido += valor;
      }

      totalPedido = parseFloat(totalPedido.toFixed(2));
      this.setState({ totalPedido }, () => {
        // this.verificaLegendaCliente(this.state.pedido.cliente.idIntegracao);
      });
    }
  }

  async loadPedidoStorage() {
    let pedidoStorage = localStorage.getItem("pedido");
    let lastPageStorage = localStorage.getItem("lastPage");

    if (pedidoStorage !== null) {
      pedidoStorage = JSON.parse(pedidoStorage);
      if (pedidoStorage.cliente !== null) {
        delete pedidoStorage.cliente.label;
      }
    }

    if (this.state.actionPage === "CADASTRAR") {
      if (pedidoStorage !== null) {
        if (
          lastPageStorage !== null &&
          (lastPageStorage === "adicionarItens" ||
            lastPageStorage === "pedidoInfo" ||
            lastPageStorage === "editarCliente")
        ) {
          this.setState({ pedido: pedidoStorage }, () => {
            if (pedidoStorage.cliente !== null) {
              this.handleChangeSelect(pedidoStorage.cliente, "cliente");
            } else {
              let clienteCorrigirStorage =
                localStorage.getItem("clienteCorrigir");

              if (clienteCorrigirStorage !== null) {
                clienteCorrigirStorage = JSON.parse(clienteCorrigirStorage);

                this.handleChangeSelect(
                  clienteCorrigirStorage,
                  "cliente",
                  true
                );
              }
            }
          });
        } else {
          localStorage.removeItem("pedido");
        }
      } else {
        let idAgenda = queryString.parse(this.props.location.search).agenda;
        let idCliente = queryString.parse(this.props.location.search).cliente;

        if (idAgenda !== undefined) {
          localStorage.setItem("idAgendaFinalizarPedido", idAgenda);

          this.setState({
            pedido: { ...this.state.pedido, idAgenda: idAgenda },
          });
        }

        if (idCliente !== undefined) {
          this.handleChangeSelect({ _id: idCliente }, "cliente", true);
        }
      }
    }

    if (this.state.actionPage === "EDITAR") {
      const idPedido = this.state.idPedido;
      let pedidoBanco = await pedidoModel.findById2(this.state.db, idPedido);
      let orcamentoStorage = localStorage.getItem("orcamento");

      if (orcamentoStorage !== null) {
        orcamentoStorage = JSON.parse(orcamentoStorage);
      }

      if (pedidoBanco === null) {
        return this.props.history.push("/home");
      }

      if (!pedidoBanco.expiracao.permitidoAlteracao) {//PEDIDO EXPIRADO OU INATIVO
        return this.props.history.push("/home");
      }

      await this.setState({
        revPedido: pedidoBanco._rev,
        codigoPedido: pedidoBanco.codigo,
        status: pedidoBanco.status,
        pedidoData: pedidoBanco.data,
      });

      if (orcamentoStorage !== null) {
        if (
          (lastPageStorage !== null && lastPageStorage === "adicionarItens") ||
          lastPageStorage === "pedidoInfo"
        ) {
          this.setState({ pedido: orcamentoStorage }, () => {
            this.handleChangeSelect(orcamentoStorage.cliente, "cliente");
          });
          return false;
        }
      }

      let pedido = {};

      pedido.tipoPedido = this.state.tiposPedido.find(
        (i) => i.idIntegracao === pedidoBanco.tipoPedido.idIntegracao
      );

      pedido.condPagto = this.state.condicoesPagamento.find(
        (i) => i.idIntegracao === pedidoBanco.condPagto.idIntegracao
      );

      pedido.formaPagto = this.state.formasPagamento.find(
        (i) => i.idIntegracao === pedidoBanco.formaPagto.idIntegracao
      );

      pedido.transportadora = this.state.transportadoras.find(
        (i) => i.idIntegracao === pedidoBanco.transportadora.idIntegracao
      );

      pedido.observacao = pedidoBanco.observacao;

      let cliente = await clienteModel.findById(
        this.state.db,
        pedidoBanco.cliente._id
      );
      cliente.value = cliente.descFormat;
      cliente.label = cliente.descFormat;
      // if (titulo) {
      //   cliente.label = (
      //     <span
      //       dangerouslySetInnerHTML={{
      //         __html: `<i class="fa fa-file" style="color: red"></i> ${cliente.descFormat}`,
      //       }}
      //     ></span>
      //   );
      // } else {
      //   cliente.label = cliente.descFormat;
      // }
      let contatos = cliente.contatos;
      contatos = this.transformDataComboBox(contatos);
      let enderecos = cliente.enderecos;
      enderecos = enderecos.map((endereco) => {
        endereco.value = endereco.endereco;
        endereco.label = `${endereco.endereco}, ${endereco.numero}`;
        return endereco;
      });

      pedido.cliente = cliente;

      let habilitarCampoCondicao = true;

      if (
        pedido.cliente.condPagto !== null &&
        pedido.cliente.condPagto !== undefined
      ) {
        if (!PERMITIR_ALTERAR_CONDICAO_PAGAMENTO) {
          habilitarCampoCondicao = false;
        }
      }

      if (pedidoBanco.contato === null) {
        pedido.contato = contatos.find(
          (i) => i.idIntegracao === pedidoBanco.contato.idIntegracao
        );
      } else {
        pedido.contato = pedidoBanco.contato;
        pedido.contato.value = pedido.contato.desc;
        pedido.contato.label = pedido.contato.desc;
      }

      if (pedidoBanco.enderecoEntrega === null) {
        pedido.endereco = enderecos.find(
          (i) => i.idIntegracao === pedidoBanco.enderecoEntrega.idIntegracao
        );
      } else {
        pedido.endereco = pedidoBanco.enderecoEntrega;
        pedido.endereco.value = pedido.endereco.endereco;
        pedido.endereco.label = `${pedido.endereco.endereco}, ${pedido.endereco.numero}`;
      }

      pedido.itens = [];
      pedido.expiracao = pedidoBanco.expiracao;

      for (let itemOrcamento of pedidoBanco.itens) {
        let produto = itemOrcamento.produto;

        let testeFelipe = await produtoModel.getGiro(
          this.state.db,
          produto._id
        );

        produto.giro = testeFelipe.giro;
        produto.imagemPrincipal = testeFelipe.imagemPrincipal;
        itemOrcamento = this.removeDesconto(itemOrcamento);
      }

      pedido.itens = pedidoBanco.itens;
      pedido.status = pedidoBanco.status;
      pedido.previsaoEntrega = new Date(pedidoBanco.previsaoEntrega);
      pedido.desconto = pedidoBanco.desconto;

      if (pedido.desconto !== null) {
        pedido.desconto.value = pedido.desconto.desc;
        pedido.desconto.label = pedido.desconto.desc;
      }

      let idAgenda = null;

      if (pedidoBanco.idAgenda !== undefined && pedidoBanco.idAgenda !== null) {
        idAgenda = pedidoBanco.idAgenda;
      }

      pedido.idAgenda = idAgenda;
      pedido.ordemCompra = pedidoBanco.ordemCompra;
      this.setState(
        { pedido: pedido, contatos, enderecos, habilitarCampoCondicao },
        () => {
          //localStorage.setItem("pedido", JSON.stringify(this.state.pedido));
        }
      );
    }
  }

  async loadSequenciaPedido() {
    let sequencia = await sequenciaPedidoModel.get(this.state.db);
    sequencia = `${this.state.usuario.codWeb}/${sequencia
      .toString()
      .padStart(4, 0)}`;
    this.setState({ codigoPedido: sequencia });
  }

  getDefaultPedido() {
    return {
      tipoPedido: null,
      cliente: null,
      condPagto: null,
      formaPagto: null,
      transportadora: null,
      itens: [],
      contato: null,
      endereco: {
        endereco: "",
        bairro: "",
        cidade: "",
        uf: "",
      },
      observacao: "",
      previsaoEntrega: new Date(),
      desconto: null,
      expiracao: null,
      status: "A",
      idAgenda: null,
      permitidoAlterarClientePedido: true,
      ordemCompra: "",
    };
  }

  transformDataComboBox(lista) {
    lista = lista.map((item) => {
      item.value = item.desc;
      item.label = item.desc;
      return item;
    });
    return lista;
  }

  transformDataComboBoxCliente(lista) {
    lista = lista.map((item) => {
      item.value = item.descFormat;
      item.label = item.descFormat;
      // if (item.titulos)
      //   item.label = (
      //     <span
      //       dangerouslySetInnerHTML={{
      //         __html: `<i class="fa fa-file" style="color: red"></i> ${item.descFormat}`,
      //       }}
      //     ></span>
      //   );
      // else item.label = item.descFormat;
      return item;
    });
    return lista;
  }

  async load() {
    let tiposPedidoBusca = await tipoPedidoModel.findAll(this.state.db);
    tiposPedidoBusca = this.transformDataComboBox(tiposPedidoBusca);

    // let clientesBusca = await clienteModel.findAll(this.state.db);
    //clientesBusca = this.transformDataComboBox(clientesBusca);
    // clientesBusca = clientesBusca.sort(ordenarIdIntegracao);

    let condPagamentos = await condPagamentoModel.findAll(this.state.db);
    condPagamentos = this.transformDataComboBox(condPagamentos);

    let formaPagamentosBusca = await formaPagamentoModel.findAll(this.state.db);
    formaPagamentosBusca = this.transformDataComboBox(formaPagamentosBusca);

    let transportadorasBusca = await transportadoraModel.findAll(this.state.db);
    transportadorasBusca = this.transformDataComboBox(transportadorasBusca);

    this.setState({
      tiposPedido: tiposPedidoBusca,
      // clientes: clientesBusca,
      condicoesPagamento: condPagamentos,
      formasPagamento: formaPagamentosBusca,
      transportadoras: transportadorasBusca,
    });
  }

  setTipoPedidoPadrao() {
    let tipoPedidoPadrao = this.state.tiposPedido.find(
      (item) => item.padrao === true
    );

    if (tipoPedidoPadrao !== undefined) {
      let localPedido = this.state.pedido;
      localPedido.tipoPedido = tipoPedidoPadrao;
      this.setState({ pedido: localPedido });
    }
  }

  async handleChangeSelect(item, tipo, clienteSelecionadoNovo = false) {
    let pedidoLocal = this.state.pedido;
    let clienteCorrigir = Object.assign({}, item);

    if (tipo === "cliente") {
      item = await this.buscaDadosCliente(item._id);

      if (item === null) {
        this.notificar(
          "error",
          "Este cliente não esta mais na carteira do vendedor."
        );

        setTimeout(() => {
          this.props.history.push("/home");
        }, 2000);
        return false;
      }

      let titulos = await clienteModel.findTitulo(
        this.state.db,
        item.idIntegracao
      );

      item.value = item.descFormat;
      item.label = item.descFormat;

      if (titulos.length) {
        item.label = (
          <span
            dangerouslySetInnerHTML={{
              __html: `<i class="fa fa-file" style="color: red"></i> ${item.descFormat}`,
            }}
          ></span>
        );
      }

      let contatos = item.contatos;
      contatos = this.transformDataComboBox(contatos);
      let enderecos = item.enderecos;
      enderecos = enderecos.map((endereco) => {
        endereco.value = endereco.endereco;
        endereco.label = `${endereco.endereco}, ${endereco.numero}`;
        return endereco;
      });

      let clienteValido = true;

      for (let contato of contatos) {
        if (contato.status === "A") {
          // this.setState({ modal: true, idCliente: item._id });
          // clienteValido = false;
          // break;

          if (contato.email === "" || contato.fone === "") {
            this.setState({ modal: true, idCliente: item._id });
            clienteValido = false;
            break;
          }
        }
      }

      // clienteValido = false;

      if (!clienteValido) {
        localStorage.setItem(
          "clienteCorrigir",
          JSON.stringify(clienteCorrigir)
        );
        return false;
      } else {
        pedidoLocal.contato = contatos.find((cont) => cont.padrao === true);

        if (clienteSelecionadoNovo) {
          pedidoLocal.endereco = enderecos.find(
            (end) => end.principal === true
          );
        }

        pedidoLocal.cliente = item;
        pedidoLocal = this.setarInfoSugerida(pedidoLocal);
        let habilitarCampoCondicao = true;

        if (
          pedidoLocal.cliente.condPagto !== null &&
          pedidoLocal.cliente.condPagto !== undefined
        ) {
          if (!PERMITIR_ALTERAR_CONDICAO_PAGAMENTO) {
            habilitarCampoCondicao = false;
          }
        }

        this.setState(
          {
            contatos,
            enderecos,
            pedido: pedidoLocal,
            limiteCreditoCliente: item.limiteCredito,
            habilitarCampoCondicao,
          },
          () => {
            //localStorage.setItem("pedido", JSON.stringify(this.state.pedido));
            this.verificaLegendaCliente(item.idIntegracao);
          }
        );
      }
    } else if (tipo === "condPagto" || tipo === "desconto") {
      this.setState({ pedido: { ...this.state.pedido, [tipo]: item } }, () => {
        this.calcularTotalPedido();
      });
    } else {
      this.setState({ pedido: { ...this.state.pedido, [tipo]: item } });
    }
  }

  verificaLegendaCliente(idIntegracaoCliente) {
    let alertaClientes = localStorage.getItem("legendaCliente");

    if (alertaClientes !== null) {
      alertaClientes = JSON.parse(alertaClientes);
      let clienteFind = alertaClientes.clientes.find(
        (i) => i === idIntegracaoCliente
      );

      if (clienteFind !== undefined) {
        this.setState({
          exibirLegendaCliente: true,
          textoLegenda:
            "Cliente possui títulos em atraso. Sujeito a aprovação do Depto. Financeiro da empresa",
          corLegenda: "#dc494a",
        });
      } else {
        let limiteCredito = this.state.limiteCreditoCliente;

        if (limiteCredito !== null) {
          if (this.state.totalPedido > limiteCredito) {
            this.setState({
              exibirLegendaCliente: true,
              textoLegenda:
                "Total do pedido acima do limite de crédito do cliente. Sujeito a aprovação do Depto. Financeiro da empresa.",
              corLegenda: "#F59C00",
            });
          } else {
            this.setState({
              exibirLegendaCliente: false,
              textoLegenda: "",
              corLegenda: "",
            });
          }
        }
      }
    }
  }

  handleChangeInput(e, tipo) {
    this.setState({ pedido: { ...this.state.pedido, [tipo]: e.target.value } });
  }

  validarPedido() {
    let errorsLocal = this.state.errors;
    let pedido = this.state.pedido;
    let camposObrigatorios = [
      "tipoPedido",
      "cliente",
      "condPagto",
      "formaPagto",
      "transportadora",
      "contato",
    ];

    let valido = true;

    for (let campo of camposObrigatorios) {
      if (pedido[campo] === null) {
        errorsLocal[campo] = true;
        valido = false;
      } else {
        errorsLocal[campo] = false;
      }
    }

    if (pedido.endereco.endereco === "") {
      errorsLocal.endereco = true;
      valido = false;
    } else {
      errorsLocal.endereco = false;
    }

    this.setState({ errors: errorsLocal });
    return valido;
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  setarInfoSugerida(pedido) {
    let itensSugerir = [
      { item: "formaPagto", lista: this.state.formasPagamento },
      { item: "condPagto", lista: this.state.condicoesPagamento },
      { item: "transportadora", lista: this.state.transportadoras },
    ];

    for (let itemSugerir of itensSugerir) {
      if (
        pedido.cliente[itemSugerir.item] !== undefined &&
        pedido.cliente[itemSugerir.item] !== null
      ) {
        let itemBusca = itemSugerir.lista.find(
          (item) =>
            item.idIntegracao === pedido.cliente[itemSugerir.item].idIntegracao
        );
        if (itemBusca !== undefined) {
          if (pedido[itemSugerir.item] === null) {
            pedido[itemSugerir.item] = itemBusca;
          }
        }
      }
    }

    return pedido;
  }

  async buscaDadosCliente(id) {
    let cliente = await clienteModel.findById(this.state.db, id);
    return cliente;
  }

  promiseOptions(inputValue) {
    return new Promise((resolve) => {
      setTimeout(async () => {
        if (inputValue === "") {
          // let clientes = [];
          // let clientes = await clienteModel.findAll(this.state.db);
          let clientes = await clienteModel.findAllTeste(this.state.db);
          clientes = this.transformDataComboBoxCliente(clientes);
          this.setState({ clientes });

          resolve(clientes);
        } else {
          let aux = inputValue.substr(0, 1);
          let len = 2;
          if (aux == "&" || aux == "%") len = 3;
          if (inputValue.length >= len) {
            let clientes = await clienteModel.findAllByDesc(
              this.state.db,
              inputValue
            );

            clientes = this.transformDataComboBoxCliente(clientes);
            this.setState({ clientes });
            resolve(clientes);
          } else {
            resolve([]);
          }
        }
      }, 100);
    });
  }

  abrirPaginaNovoCliente() {
    localStorage.removeItem("clienteNovo");
    this.props.history.push("/novoClientes");
  }

  abrirPaginaInfoPedido() {
    if (this.state.pedido.cliente === null) {
      this.notificar("warning", "Selecione o cliente para continuar!");
      return false;
    }

    let url = `/pedidos-novo-info`;

    if (this.state.actionPage === "CADASTRAR") {
      localStorage.setItem("pedido", JSON.stringify(this.state.pedido));
    } else if (this.state.actionPage === "EDITAR") {
      localStorage.setItem("orcamento", JSON.stringify(this.state.pedido));
      url = url + `?id=${this.state.idPedido}`;
    }

    return this.props.history.push(url);
  }

  calcularValorDesconto(valor, porcentagemDesconto) {
    valor = parseFloat(valor.toFixed(2));
    return valor - valor * (porcentagemDesconto / 100);
  }

  promiseOptionsDesconto(inputValue) {
    return new Promise((resolve) => {
      setTimeout(async () => {
        if (inputValue === "") {
          let descontos = await descontoModel.findAll(this.state.db);

          descontos = descontos.map((desconto) => {
            desconto.label = desconto.desc;
            desconto.value = desconto.desc;
            return desconto;
          });
          this.setState({ descontos });

          resolve(descontos);
        } else {
          if (inputValue.length >= 3) {
            let descontos = await descontoModel.findAllByDesc(
              this.state.db,
              inputValue
            );

            descontos = descontos.map((desconto) => {
              desconto.label = desconto.desc;
              desconto.value = desconto.desc;
              return desconto;
            });
            this.setState({ descontos });
            resolve(descontos);
          } else {
            resolve([]);
          }
        }
      }, 100);
    });
  }

  removeDesconto(itemPedido) {
    itemPedido.produto.preco.precoUnitComImpostosFinal =
      itemPedido.produto.preco.precoUnitComImpostos;

    if (itemPedido.produto.preco.pAcrescimo > 0) {
      let valor2 = parseFloat(
        (
          (itemPedido.produto.preco.pAcrescimo *
            itemPedido.produto.preco.precoUnitComImpostos) /
          100
        ).toFixed(2)
      );
      itemPedido.produto.preco.precoUnitComImpostosFinal = parseFloat(
        (itemPedido.produto.preco.precoUnitComImpostos + valor2).toFixed(2)
      );
    }

    if (itemPedido.produto.preco.pDesconto > 0) {
      let valor = parseFloat(
        (
          (itemPedido.produto.preco.pDesconto *
            itemPedido.produto.preco.precoUnitComImpostos) /
          100
        ).toFixed(2)
      );

      itemPedido.produto.preco.precoUnitComImpostosFinal = parseFloat(
        (itemPedido.produto.preco.precoUnitComImpostos - valor).toFixed(2)
      );
    }

    itemPedido.produto.preco.precoTotalComImpostosFinal = parseFloat(
      itemPedido.quantidade *
        itemPedido.produto.preco.precoUnitComImpostosFinal.toFixed(2)
    );

    return itemPedido;
  }

  toggle() {
    this.setState({ modal: !this.state.modal });
  }

  abrirPaginaEditarContatos() {
    localStorage.setItem("urlAnterior", this.props.history.location.pathname);
    localStorage.setItem("pedido", JSON.stringify(this.state.pedido));
    this.props.history.push(`/contatos/editar?id=${this.state.idCliente}`);
  }

  async atualizaSaldoOver(vendedor, itens, idPedido) {
    let descontoTotal = 0;
    let acrescimoTotal = 0;

    for (let item of itens) {
      if (item.produto.preco.valorAcrescimo > 0) {
        acrescimoTotal +=
          item.produto.preco.valorAcrescimo * parseFloat(item.quantidade);
      }

      if (item.produto.preco.valorDesconto > 0) {
        descontoTotal +=
          item.produto.preco.valorDesconto * parseFloat(item.quantidade);
      }
    }

    let novoSaldo = vendedor.vlOver - descontoTotal;
    novoSaldo += acrescimoTotal;

    let diferencaSaldoOver = Math.abs(vendedor.vlOver - novoSaldo);
    diferencaSaldoOver = formatarCasaDecimal(diferencaSaldoOver);

    if (novoSaldo !== vendedor.vlOver) {
      await saldoOverModel.update(
        this.state.db,
        idPedido,
        diferencaSaldoOver,
        novoSaldo > vendedor.vlOver ? "A" : "D",
        vendedor.idIntegracao
      );
    }
  }

  abrirPaginasEtapa(pagina) {
    if (pagina !== "pedido" && this.state.pedido.cliente === null) {
      this.notificar("warning", "Selecione o cliente para continuar!");
      return false;
    }

    if (this.state.actionPage === "CADASTRAR") {
      localStorage.setItem("pedido", JSON.stringify(this.state.pedido));
    } else if (this.state.actionPage === "EDITAR") {
      localStorage.setItem("orcamento", JSON.stringify(this.state.pedido));
    }

    let url = "";

    if (pagina === "pedido") {
      url = "/pedidos-novo";
    } else if (pagina === "pedidoInfo") {
      url = "/pedidos-novo-info";
    } else if (pagina === "carrinho") {
      url = "/carrinho";
    } else if (pagina === "revisao") {
      url = "/pedidos-revisao";
    }
    if (this.state.actionPage === "EDITAR") {
      url = url + `?id=${this.state.idPedido}`;
    }
    this.props.history.push(url);
  }

  async buscarTitulosAtraso() {
    let titulos = await clienteModel.buscarTitulos(
      this.state.db,
      this.state.pedido.cliente.idIntegracao
    );

    if (titulos.length) {
      this.setState(
        {
          titulosAtraso: titulos[0].titulos,
          valorTitulos: titulos[0].vlDebitos,
        },
        () => {
          this.toggleModalTitulos();
        }
      );
    }
  }

  async verificaLegendaCliente(idIntegracaoCliente) {
    let existeTitulos = await clienteModel.verificaExisteTitulos(
      this.state.db,
      idIntegracaoCliente
    );

    this.setState({
      existeTitulosAtraso: existeTitulos,
    });
  }

  toggleModalTitulos() {
    this.setState({ modalTitulos: !this.state.modalTitulos });
  }

  async verificaAutenticacao() {
    await axios
      .post(
        `${this.props.getBaseUrlApi()}/verifica-autenticacao-pedidos`,
        {
          idUsuario: localStorage.getItem("idUsuario"),
          hash: localStorage.getItem("hash"),
        },
        this.props.parameters()
      )
      .then((response) => {
        if (!response.data.valido) {
          this.props.logout();
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push("/home");
          }
        }
      });
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="container-scroller font-app">
          <NavBar
            title={
              this.state.actionPage === "CADASTRAR"
                ? `Novo Pedido`
                : `Editar Orçamento`
            }
          />
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"novoPedido"} />
            <div className="main-panel">
              <div className="content-wrapper" style={{ position: "relative" }}>
                <div>
                  <ul
                    id="alterUl"
                    className="nav nav-tabs justify-content-center process-model more-icon-preocess"
                    role="tablist"
                    style={{ margin: "0px auto 26px" }}
                  >
                    <li id="li-cliente" role="presentation" className="active">
                      <a aria-controls="discover" role="tab" data-toggle="tab">
                        <i className="fa fa-plus" aria-hidden="true"></i>
                        <p>Pedido</p>
                      </a>
                    </li>

                    <li
                      id="li-info"
                      role="presentation"
                      onClick={() => {
                        this.abrirPaginasEtapa("pedidoInfo");
                      }}
                    >
                      <a aria-controls="content" role="tab" data-toggle="tab">
                        <i className="fa fa-newspaper-o" aria-hidden="true"></i>
                        <p>Info adicionais</p>
                      </a>
                    </li>
                    <li
                      id="li-info"
                      onClick={() => {
                        this.abrirPaginasEtapa("carrinho");
                      }}
                    >
                      <a aria-controls="content" role="tab" data-toggle="tab">
                        <i
                          className="fa fa-shopping-cart"
                          aria-hidden="true"
                        ></i>
                        <p>Itens</p>
                      </a>
                    </li>
                    <li
                      id="li-info"
                      role="presentation"
                      onClick={() => {
                        this.abrirPaginasEtapa("revisao");
                      }}
                    >
                      <a aria-controls="content" role="tab" data-toggle="tab">
                        <i className="fa fa-edit" aria-hidden="true"></i>
                        <p>Revisão</p>
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="row">
                  <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body dashboard-tabs p-0">
                        <div className="tab-content py-0 px-0">
                          <div
                            className="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                            aria-labelledby="overview-tab"
                          >
                            <div className="d-flex flex-wrap justify-content-xl-between">
                              <div
                                style={{
                                  padding: "15px",
                                  float: "left",
                                  width: "100%",
                                }}
                              >
                                {/* <div
                                  className="float-left width-100"
                                  style={{
                                    borderBottom: "1px solid #CCC",
                                    padding: "5px 0",
                                  }}
                                >
                                  CADASTRAR PEDIDO
                                </div> */}

                                <div
                                  className="row font-size-13"
                                  style={{ padding: "10px" }}
                                >
                                  <div className="col-md-2 pd-pedido">
                                    <div className="form-group">
                                      <label className="font-size-14">
                                        Código
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control font-size-14"
                                        value={`#${this.state.codigoPedido}`}
                                        disabled={true}
                                        style={{
                                          color: "#5f9f1a",
                                          fontWeight: "bold",
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-2 pd-pedido">
                                    <div className="form-group">
                                      <label className="font-size-14">
                                        Tipo de Pedido
                                      </label>
                                      <Select
                                        options={this.state.tiposPedido}
                                        value={this.state.pedido.tipoPedido}
                                        onChange={(item) =>
                                          this.handleChangeSelect(
                                            item,
                                            "tipoPedido"
                                          )
                                        }
                                        className={`font-size-14 ${
                                          this.state.errors.tipoPedido
                                            ? "select-error"
                                            : ""
                                        }`}
                                        placeholder="Selecione"
                                        isDisabled={
                                          this.state.pedido.status === "I"
                                            ? true
                                            : false
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-6 pd-pedido">
                                    <div className="form-group">
                                      <label
                                        className="font-size-14"
                                        style={{ marginRight: "3px" }}
                                      >
                                        Cliente{" "}
                                        {this.state.existeTitulosAtraso && (
                                          <span
                                            style={{
                                              position: "relative",
                                              cursor: "pointer",
                                            }}
                                            id="legendaCliente"
                                            onClick={() => {
                                              this.buscarTitulosAtraso();
                                            }}
                                          >
                                            <i
                                              className="fa fa-circle"
                                              style={{
                                                color: "#dc494a",
                                              }}
                                            ></i>
                                            <span className="icone-info">
                                              i
                                            </span>
                                          </span>
                                        )}
                                        <span
                                          style={{
                                            //fontSize: "22px",
                                            paddingLeft: "5px",
                                            paddingTop: "24px",
                                            cursor: "pointer",
                                            color: "#888",
                                          }}
                                          onClick={this.abrirPaginaNovoCliente}
                                        >
                                          <i
                                            className="fa fa-user-plus"
                                            aria-hidden="true"
                                            style={{ color: "#5f9f1a" }}
                                            id="adicionarCliente"
                                          ></i>

                                          <UncontrolledTooltip
                                            placement="right"
                                            target="adicionarCliente"
                                          >
                                            Adicionar Cliente
                                          </UncontrolledTooltip>
                                        </span>
                                      </label>{" "}
                                      {this.state.exibirLegendaCliente && (
                                        <React.Fragment>
                                          <span
                                            style={{
                                              position: "relative",
                                              cursor: "pointer",
                                            }}
                                            id="legendaCliente"
                                          >
                                            <i
                                              className="fa fa-circle"
                                              style={{
                                                color: this.state.corLegenda,
                                              }}
                                            ></i>
                                            <span className="icone-info">
                                              i
                                            </span>
                                          </span>

                                          <UncontrolledTooltip
                                            placement="right"
                                            target="legendaCliente"
                                          >
                                            {this.state.textoLegenda}
                                          </UncontrolledTooltip>
                                        </React.Fragment>
                                      )}
                                      <AsyncSelect
                                        cacheOptions
                                        defaultOptions
                                        //  loadOptions={this.promiseOptions}
                                        loadOptions={(inputValue) =>
                                          this.debouncedLoadOptions(inputValue)
                                        }
                                        value={this.state.pedido.cliente}
                                        onChange={(item) =>
                                          this.handleChangeSelect(
                                            item,
                                            "cliente",
                                            true
                                          )
                                        }
                                        className={`font-size-14 ${
                                          this.state.errors.cliente
                                            ? "select-error"
                                            : ""
                                        }`}
                                        placeholder="Pesquise pela fantasia ou código"
                                        isDisabled={
                                          !this.state.pedido
                                            .permitidoAlterarClientePedido
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-2 pd-pedido">
                                    <div className="form-group">
                                      <label className="font-size-14">
                                        Forma de pagamento
                                      </label>
                                      <Select
                                        options={this.state.formasPagamento}
                                        value={this.state.pedido.formaPagto}
                                        onChange={(item) =>
                                          this.handleChangeSelect(
                                            item,
                                            "formaPagto"
                                          )
                                        }
                                        className={`font-size-14 ${
                                          this.state.errors.formaPagto
                                            ? "select-error"
                                            : ""
                                        }`}
                                        placeholder="Selecione"
                                        isDisabled={
                                          this.state.pedido.status === "I"
                                            ? true
                                            : false
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-2 pd-pedido">
                                    <div className="form-group">
                                      <label className="font-size-14">
                                        Condição de Pagto
                                      </label>
                                      <Select
                                        options={this.state.condicoesPagamento}
                                        value={this.state.pedido.condPagto}
                                        onChange={(item) =>
                                          this.handleChangeSelect(
                                            item,
                                            "condPagto"
                                          )
                                        }
                                        className={`font-size-14 ${
                                          this.state.errors.condPagto
                                            ? "select-error"
                                            : ""
                                        }`}
                                        placeholder="Selecione"
                                        isDisabled={
                                          this.state.pedido.status === "I"
                                            ? true
                                            : this.state.habilitarCampoCondicao
                                            ? false
                                            : true
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div
                                    className={`col-md-1 pd-pedido porcentagem-desconto font-13`}
                                  >
                                    <div className="form-group">
                                      <label className="font-size-14">
                                        Desconto
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control text-right font-size-14"
                                        disabled={true}
                                        value={
                                          this.state.pedido.condPagto !== null
                                            ? `${this.state.pedido.condPagto.pDesc
                                                .toFixed(2)
                                                .replace(".", ",")}%`
                                            : "0,00%"
                                        }
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-5 pd-pedido">
                                    <div className="form-group">
                                      <label className="font-size-14">
                                        Transportadora
                                      </label>
                                      <Select
                                        options={this.state.transportadoras}
                                        value={this.state.pedido.transportadora}
                                        onChange={(item) =>
                                          this.handleChangeSelect(
                                            item,
                                            "transportadora"
                                          )
                                        }
                                        className={`font-size-14 ${
                                          this.state.errors.transportadora
                                            ? "select-error"
                                            : ""
                                        }`}
                                        placeholder="Selecione"
                                        isDisabled={
                                          this.state.pedido.status === "I"
                                            ? true
                                            : false
                                        }
                                      />
                                    </div>
                                  </div>
                                  {this.state.parametros !== null &&
                                    this.state.parametros.tipoDesconto ===
                                      "progressivo" && (
                                      <React.Fragment>
                                        <div className="col-md-2 pd-pedido">
                                          <div className="form-group">
                                            <label className="font-size-14">
                                              Desconto progressivo
                                            </label>
                                            <AsyncSelect
                                              cacheOptions
                                              defaultOptions
                                              loadOptions={
                                                this.promiseOptionsDesconto
                                              }
                                              value={this.state.pedido.desconto}
                                              onChange={(item) =>
                                                this.handleChangeSelect(
                                                  item,
                                                  "desconto"
                                                )
                                              }
                                              placeholder="Selecione"
                                              className="font-size-14"
                                            />
                                            {this.state.pedido.desconto !==
                                              null && (
                                              <small
                                                style={{ cursor: "pointer" }}
                                                onClick={(e) => {
                                                  this.setState(
                                                    {
                                                      pedido: {
                                                        ...this.state.pedido,
                                                        desconto: null,
                                                      },
                                                    },
                                                    () => {
                                                      this.calcularTotalPedido();
                                                    }
                                                  );
                                                }}
                                              >
                                                Remover desconto
                                              </small>
                                            )}
                                          </div>
                                        </div>
                                      </React.Fragment>
                                    )}

                                  {/* <div className="col-md-2 pd-pedido">
                                    <div className="form-group">
                                      <label className="font-size-14">
                                        Total do pedido
                                      </label>

                                      <input
                                        type="text"
                                        className="form-control font-size-14 text-right"
                                        value={`R$ ${formatarReal(
                                          this.state.totalPedido
                                        )}`}
                                        disabled={true}
                                        style={{
                                          color: "#7dd421",
                                          fontWeight: "bold",
                                        }}
                                      />
                                    </div>
                                  </div> */}
                                  <div className="d-flex float-left w-100 pd-pedido">
                                    <div style={{ margin: "5px" }}>
                                      <button
                                        className="btn btn-success"
                                        onClick={() =>
                                          this.abrirPaginaInfoPedido()
                                        }
                                      >
                                        Próximo
                                      </button>
                                    </div>

                                    {/* <div
                                      className="float-left text-center"
                                      style={{ width: "50%" }}
                                    >
                                      <button
                                        className="btn btn-app-cinza md float-left font-13"
                                        disabled={
                                          this.state.pedido.cliente === null ||
                                          this.state.pedido.status === "I"
                                            ? true
                                            : false
                                        }
                                        onClick={(e) =>
                                          this.abrirPaginaInfoPedido()
                                        }
                                        style={{ margin: "0 2px" }}
                                      >
                                        Mais informações
                                      </button>
                                    </div> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    position: "fixed",
                    textAlign: "center",
                    width: "calc(100% - 257px)",
                    textAlign: "center",
                    paddingRight: "35px",
                  }}
                >
                  <div style={{ fontSize: "18px", fontWeight: "bold" }}>
                    Valor Total:{" "}
                    <span style={{ color: "rgb(126, 211, 33)" }}>
                      R$ {formatarReal(this.state.totalPedido)}
                    </span>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>

        <Modal
          isOpen={this.state.modalTitulos}
          toggle={this.toggleModalTitulos}
        >
          <ModalHeader>Títulos em Atraso</ModalHeader>
          <ModalBody>
            <div className="form-group col-md-12 row table-responsive setting-top">
              <table
                className="table table-hover table-striped"
                style={{ fontSize: "14px" }}
              >
                <thead className="thead-dark thead-site">
                  <tr>
                    <th className="col-3 padding-coluna-titulos text-right">
                      Título
                    </th>
                    <th className="col-3 padding-coluna-titulos text-right">
                      Emissão
                    </th>
                    <th className="col-3 padding-coluna-titulos text-right">
                      Vencimento
                    </th>
                    <th className="col-3 padding-coluna-titulos text-right">
                      Valor (R$)
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {this.state.titulosAtraso.map((item, key) => {
                    return (
                      <tr key={key}>
                        <td className="text-right">{item.nrTitulo}</td>
                        <td className="text-right">
                          {moment(item.emissao).format("DD/MM/YYYY")}
                        </td>
                        <td className="text-right">
                          {moment(item.vencimento).format("DD/MM/YYYY")}
                        </td>
                        <td className="text-right">
                          {formatarReal(item.valorPendente)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <div className="col-12" style={{ marginBottom: "15px" }}>
                <div className="col-12 row">
                  <div
                    className="col-12"
                    style={{ padding: "1px", fontWeight: "bold" }}
                  >
                    Total dos Titulos: R${formatarReal(this.state.valorTitulos)}
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              className="btn btn-secondary"
              onClick={this.toggleModalTitulos}
            >
              Fechar
            </button>

            {/* <button
              className="btn btn-danger"
              onClick={() => this.abrirPaginaEditarContatos()}
            >
              Corrigir
            </button>
          */}
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}
